import { singleLineTextSchema } from "./text.js";
// Nome e cognome di una persona, sempre in due campi (decisione del product owner del 30 settembre 2026):
// identità, inviti, appartenenze e titolare dell'azienda. Il nome intero che le risposte portano ancora
// (`name`, `displayName`, `ownerName`) è derivato: lo scrive il server a ogni scrittura con `fullName`.
/** Nome oppure cognome: un testo su una riga (`text.ts`), da 1 a 60 caratteri. */
export const personNamePartSchema = singleLineTextSchema(60);
/** Nome intero derivato da nome e cognome, senza spazi ai bordi. */
export function fullName(firstName, lastName) {
    return `${firstName} ${lastName}`.trim();
}
//# sourceMappingURL=person-name.js.map